import React from 'react';
import BasePaymentsPage from './BasePaymentsPage';

function PaymentsPage() {
    return <BasePaymentsPage shouldListenForResize />;
}

PaymentsPage.displayName = 'PaymentsPage';

export default PaymentsPage;
